import { c as _c } from "react/compiler-runtime";
import { fetchProjects } from "@store/projects/projects-slice-thunk";
import { useAppDispatch } from "@store/store-helper";
import { setInitialFetchingItems } from "@store/table/table-slice";
import { useEffect } from "react";
/** Custom hook that fetches projects based on changes in the search, groupId or sortBy queries */
export function useFetchProjectsOnQueryChange(t0) {
  const $ = _c(9);
  const {
    companyId,
    projectArchivingState,
    sortBy,
    search,
    groupId,
    isEnabled: t1
  } = t0;
  const isEnabled = t1 === undefined ? true : t1;
  const dispatch = useAppDispatch();
  let t2;
  let t3;
  if ($[0] !== companyId || $[1] !== dispatch || $[2] !== groupId || $[3] !== isEnabled || $[4] !== projectArchivingState || $[5] !== search || $[6] !== sortBy) {
    t2 = () => {
      if (!isEnabled) {
        return;
      }
      dispatch(setInitialFetchingItems([]));
      dispatch(fetchProjects({
        companyId,
        projectArchivingState,
        groupId,
        search,
        sortBy
      }));
    };
    t3 = [companyId, dispatch, groupId, isEnabled, projectArchivingState, search, sortBy];
    $[0] = companyId;
    $[1] = dispatch;
    $[2] = groupId;
    $[3] = isEnabled;
    $[4] = projectArchivingState;
    $[5] = search;
    $[6] = sortBy;
    $[7] = t2;
    $[8] = t3;
  } else {
    t2 = $[7];
    t3 = $[8];
  }
  useEffect(t2, t3);
}